import { createContext } from 'react';

export interface TutorTheme {
  teacherImage: string;
  backgroundImage: string;
}

export type TutorThemeFetchSource = 'network' | 'cache' | 'fallback';

export interface TutorThemeFetchResult {
  theme: TutorTheme;
  source: TutorThemeFetchSource;
}

export interface TutorThemeContextType {
  /** Prompt Library dialect key, e.g. "standard_tamil" / "malay_baku_sg". */
  getTheme: (tenantId: string, dialectKey: string) => Promise<TutorThemeFetchResult>;
}

/** Singleton context — separate module so Vite HMR does not recreate context when the provider hot-reloads. */
export const TutorThemeContext = createContext<TutorThemeContextType | undefined>(undefined);
